<template>
    <div class="homeWrap">
        <div class="line">
            <el-row >
                <el-col :span="24">
                    <div class="numTextBlock">
                        <div class="iconBox"><i class="el-icon-notebook-2"></i></div>
                        <div class="textBox">
                            <span class="span">客户总数量</span>
                            <span class="bigFont">{{totalNum}}</span>
                            <span class="span">人</span>
                        </div>
                    </div>

                </el-col>
            </el-row>
        </div>
        <div class="line echartLine">
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="colBlock" style="padding:10px 20px;">
                        <div id="echartBox"  :style="{width:'100%',height:canvasHeight+'px'}"></div>
                    </div>
                </el-col>
            </el-row>
        </div>


    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    import {        ajaxPost,        api    } from '@/common/request.js'
    import echarts from 'echarts'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                totalNum: '-',
                echartLists:[],
                xData:[],
                numData:[],
                canvasHeight:400,
            }
        },
        methods: {
            getDetail(){
              let _this=this
              let arg={}
              ajaxPost('/admin/userProfile',arg).then(function(res) {
                  if(res.errorCode==200){
                      _this.totalNum=res.data.totalNum
                      _this.userProfileList=res.data.userProfileList?res.data.userProfileList:[]
//                       if(_this.userProfileList.length>8){
//                           _this.canvasHeight=200
//                       }else{
//                           _this.canvasHeight=410
// 
//                       }
//                       
                      _this.xData=[]
                      _this.numData=[]
                      _this.userProfileList.forEach(function(item,index){
                           _this.xData.push(item.conferenceName)
                           _this.numData.push(item.num)
                      })
                      _this.drawPie()
                  }
              }, function(res) {
              
              })  
            },
            drawPie() {
                let _this=this
                let charts = echarts.init(document.getElementById('echartBox'))
                let xData=_this.xData
                let option = {
                    title: {
                        text: '各活动参与客户总数量（人）',
                        // subtext: '数据来自网络'
                        textStyle: {
                                    color: "#6A89BE",
                                    fontWeight: "normal"
                        }
                    },
                    color: ['#3398DB'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'line'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '0%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        splitLine: {
                            show: true
                        },
                        axisLabel: {
                            show: true
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: xData,
                        axisLine: {
                            show: false
                        
                        },
                        axisTick: {
                            show: false
                        },
                    },
                    series: [{
                            name: '金额',
                            type: 'bar',
                            barWidth: 17,
                            data: _this.numData,
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        position: 'right',
                                        formatter: '{c}' + '人'
                                    }
                                }
                            },
                        }]
                };
                charts.setOption(option)
            },
        },
        mounted() {
            this.drawPie()
            this.getDetail()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .homeWrap {
        padding: 10px 20px; max-width:1300px; margin-bottom: 50px;
        .line {

            .colBlock {
                background: #fff;
                padding: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/intro.vue